module.exports = __webpack_public_path__ + "img/seagoal-logo.5501bd47.png";